/**
 * BE CHUA CANVAS.
 *
 * Rang buoc chinh cua trinh xem PDF khong phai CPU ma la BO NHO. Mot trang A4
 * o 2x DPR la khoang 1654 x 2339 pixel = 15 MB bitmap chua nen, va trinh duyet
 * con giu them ban sao phia GPU. Muoi trang la da qua nguong tren nhieu may.
 *
 * Vi vay: khong bao gio tao canvas moi cho moi trang. Muon tu be chua, tra lai
 * khi trang roi khoi vung nhin, va khi tra lai thi DAT KICH THUOC VE 0 - do la
 * cach duy nhat buoc trinh duyet giai phong bo nho anh ngay lap tuc thay vi
 * cho den luc thu gom rac.
 */

const MAX_POOLED = 8;
const pool: HTMLCanvasElement[] = [];

export function acquireCanvas(): HTMLCanvasElement {
  const reused = pool.pop();
  if (reused) return reused;
  const canvas = document.createElement('canvas');
  canvas.setAttribute('data-pdf-canvas', '');
  return canvas;
}

export function releaseCanvas(canvas: HTMLCanvasElement): void {
  // Xoa noi dung truoc khi thu nho: mot so trinh duyet giu lai bo dem cu.
  const ctx = canvas.getContext('2d');
  if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
  canvas.width = 0;
  canvas.height = 0;
  canvas.style.width = '';
  canvas.style.height = '';
  canvas.removeAttribute('data-page');
  if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
  if (pool.length < MAX_POOLED) pool.push(canvas);
}

/** Chi de hien thi trong thanh trang thai khi go loi. */
export function pooledCount(): number {
  return pool.length;
}

/**
 * Gioi han do phan giai thuc te. Tren man hinh 3x DPR va zoom 4x, mot trang A4
 * se thanh 100 MB neu ta khong chan. Chan o day, khong chan o cho goi.
 */
export const MAX_CANVAS_PIXELS = 16_000_000;

export function clampRenderScale(
  widthCss: number,
  heightCss: number,
  desiredScale: number,
): number {
  const pixels = widthCss * heightCss * desiredScale * desiredScale;
  if (pixels <= MAX_CANVAS_PIXELS) return desiredScale;
  return Math.sqrt(MAX_CANVAS_PIXELS / (widthCss * heightCss));
}
